export default "__VITE_ASSET__mKvcmP6R__"